<template>
  <div id="ProjectAttachment" class="layout-bidding-all">
    <v-card outlined class="mt-4"
      ><v-card-title>Project Attachment </v-card-title
      ><v-card-subtitle class="text--primary subtitle-2"
        >TOR Attachment</v-card-subtitle
      >
      <v-card-text>
        <v-data-table
          v-if="dataTorAttachment.length > 0"
          :headers="headers"
          :items="dataTorAttachment"
          :loading="loadingTor"
          loading-text="Loading... Please wait"
          ><template v-slot:[`item.no`]="{ index }">
            <span>{{ index + 1 }}</span> </template
          ><template v-slot:[`item.fileFullName`]="{ item }">
            <a
              class="secondary--text text-decoration-underline"
              @click="getFileAtachment(item)"
              >{{ item.fileFullName }}</a
            > </template
          ><template v-slot:[`item.createDate`]="{ item }">
            <span>{{ format(item.createDate) }}</span>
          </template></v-data-table
        ><span v-else>No file Available.</span></v-card-text
      >
      <v-divider></v-divider>
      <v-card-subtitle class="text--primary subtitle-2">
        Other Attachment</v-card-subtitle
      >
      <v-card-text>
        <v-data-table
          hide-default-footer
          v-if="dataOtherAttachment.length > 0"
          :loading="loadingOther"
          loading-text="Loading... Please wait"
          :headers="headersOther"
          :items="dataOtherAttachment"
          ><template v-slot:[`item.no`]="{ index }">
            <span>{{ index + 1 }}</span> </template
          ><template v-slot:[`item.fileFullName`]="{ item }">
            <a
              class="secondary--text text-decoration-underline"
              @click="getFileAtachment(item)"
              >{{ item.fileFullName }}</a
            > </template
          ><template v-slot:[`item.createDate`]="{ item }">
            <span>{{ format(item.createDate) }}</span>
          </template></v-data-table
        ><span v-else>No file Available.</span></v-card-text
      >
    </v-card>
  </div>
</template>

<script>
import { _projectservice } from "../../../services/projectservice";
import { dateFormat } from "../../../services/utility";

export default {
  name: "ProjectAttachment",
  data: () => ({
    dataTorAttachment: [],
    dataOtherAttachment: [],
    headers: [
      { text: "No.", value: "no" },
      { text: "File Name", value: "fileFullName" },
      { text: "Version", value: "version" },
      { text: "Created By", value: "createBy" },
      { text: "Created Date", value: "createDate" },
    ],
    headersOther: [
      { text: "No.", value: "no" },
      { text: "File Name", value: "fileFullName" },
      { text: "Description", value: "description" },
      { text: "Created By", value: "createBy" },
      { text: "Created Date", value: "createDate" },
    ],
    isHaveFileTor: false,
    loadingOther: false,
    loadingTor: false,
  }),
  async mounted() {
    await this.getTorAttachment();
    await this.getOtherAttachment();
  },
  methods: {
    async getTorAttachment() {
      this.loadingTor = true;
      this.dataTorAttachment = await _projectservice.GetAttachmentTor(
        this.$route.params.projectId
      );
      this.loadingTor = false;
      if (this.dataTorAttachment.length > 0) this.isHaveFileTor = true;
      this.callBackIsHaveFileTor();
    },

    async getOtherAttachment() {
      this.loadingOther = true;
      this.dataOtherAttachment = await _projectservice.GetAttachmentOther(
        this.$route.params.projectId
      );
      this.loadingOther = false;
    },
    async getFileAtachment(obj) {
      this.$loading(true);
      await _projectservice.GetBlobFileProject(obj.fileName, obj.fileFullName);
      this.$loading(false);
    },
    format(date) {
      return dateFormat(date);
    },
    callBackIsHaveFileTor() {
      this.$emit("emitIsHaveFileTor", this.isHaveFileTor);
    },
  },
};
</script>

<style lang="scss" scoped></style>
